module.exports = __webpack_public_path__ + "img/23.a6fd818f.png";